export default __webpack_public_path__ + "b49f09dc19affa9de6ce921666d6279e.jpg";